import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CartManager from '../services/dashboard/CartManager';

export const fetchCart = createAsyncThunk(
  'cart/fetchCart',
  async (userId) => {
    const items = await CartManager.getCartByUser(userId);
    return items || []; // fallback to empty array if null
  }
);

export const addToCartAsync = createAsyncThunk(
  'cart/addToCartAsync',
  async ({ userId, book }, { dispatch }) => {
    const newCartDto = await CartManager.addToCart(userId, book.id);
    dispatch(addToCartLocal(newCartDto));
    return newCartDto;
  }
);

export const removeFromCartAsync = createAsyncThunk(
  'cart/removeFromCartAsync',
  async ({ userId, bookId }, { dispatch }) => {
    await CartManager.removeFromCart(userId, bookId);
    dispatch(removeFromCartLocal(bookId));
    return bookId;
  }
);

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    items: [],
    status: 'idle',
    error: null,
  },
  reducers: {
    addToCartLocal: (state, action) => {
      if (!state.items) state.items = []; // defensive fix
      state.items.push(action.payload);
    },
    removeFromCartLocal: (state, action) => {
      state.items = (state.items || []).filter(c => c.book.bookId !== action.payload);
    },
    resetCart: (state) => {
      state.items = [];
    },
    clearCartLocal: (state) => {
      state.items = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCart.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCart.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload || []; // ensure it's always an array
      })
      .addCase(fetchCart.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
});

export const {
  addToCartLocal,
  removeFromCartLocal,
  clearCartLocal,
  resetCart
} = cartSlice.actions;

export default cartSlice.reducer;
